"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListDescription = void 0;
var _uiKit = require("@cian/ui-kit");
var React = _interopRequireWildcard(require("react"));
var styles = _interopRequireWildcard(require("./ListDescription.css"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ListDescription = _ref => {
  let {
    list,
    text
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, text && /*#__PURE__*/React.createElement(_uiKit.UIText1, null, text), /*#__PURE__*/React.createElement("ul", {
    className: styles['list']
  }, list.map((text, index) => /*#__PURE__*/React.createElement("li", {
    key: index,
    className: styles['item']
  }, /*#__PURE__*/React.createElement(_uiKit.UIText1, null, text)))));
};
exports.ListDescription = ListDescription;